import React, { useState, useEffect, useContext } from 'react';
import { MenuTab, MenuTabs } from './MenuTabs';
import MenuContext, { MenuProvider } from './MenuContext';
import styles from './MenuTabs.module.css';
import Report1 from './Report1';
import Report2 from './Report2';
import Report3 from './Report3';


function WorkflowReportMenu({ Product, Location , Workflow}) {
    const { activeTab, setActiveTab } = useContext(MenuContext);

    useEffect(() => {
        setActiveTab('Report1');
    }, [Product, Location]);  // Update activeTab when Product or Location changes

    const changeMenu = (menu) => {
        setActiveTab(menu);
        //console.log(setActiveTab);
    }
    return (
        // <MenuProvider>
            <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12">
                    <div className='indentation'>
                        <MenuTabs name="WorkflowReport" changeHandler={changeMenu} tabState={{ activeTab: activeTab }} style={styles} >
                            <MenuTab label='Report1' name='Actual vs Prediction' key='1'>
                                <Report1 Product={Product} Location={Location}  />
                            </MenuTab>
                            <MenuTab label='Report2' name='MAPE Report' key='2'>
                                <Report2 Product={Product} Location={Location}  />
                            </MenuTab>
                            <MenuTab label='Report3' name='Forecast Report' key='3'>
                                <Report3 Product={Product} Location={Location} Workflow={Workflow}  />
                            </MenuTab>
                        </MenuTabs>
                    </div>
                </div>
            </div>
        // </MenuProvider>

    )
}

export default WorkflowReportMenu;
